import '../modalWrapper.scss';
import './modal-error.scss';

import Caution from '../../../../assets/images/icons/warning.png';

import React, { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../../features';
import { setModalSignInUp } from '../../../../store/AppSlice';
import { modalTypeEnum } from '../../../../types/modal';

export const ModalServerError: FunctionComponent = () => {

    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setModalSignInUp(modalTypeEnum.none));
    }

    return (
        <div className="modal modal-server-error">
            <img src={Caution} alt="" />
            <h1>
                Oops, Ocorreu um Erro
            </h1>
            <p>
                O servidor encontrou um erro temporário e não pôde concluir sua solicitação. Por favor, tente novamente mais tarde.
            </p>
            <button onClick={handleClick}>
                Fechar
            </button>
                
        </div>
    )
}
